import React, { useEffect, useState } from 'react'
import { Delay, _ToNormal, isNumber } from '../../../../Utils/helper';
import { INSERT_ISSUER_DOCUMENT, UPDATE_DOCUMENT_DATA } from '../../../../Utils/constant'
import { WithInputType } from '../../../../components/Inputs'
import Each from '../../../../components/Each'
import cogoToast from 'cogo-toast-react-17-fix';
import API from '../../../../ApiConfig'
import _ from 'lodash'
import Loader from '../../../../components/Loader';
import BtnLoader from '../../../../components/BtnLoader';
import { BUTTONS } from '../../../../Utils/Strings';
import Icon from 'react-icons-kit';
import { informationCircled } from 'react-icons-kit/ionicons/informationCircled'
import { useSelector } from 'react-redux';


// fieldType 2 => Dropdown (see src/components/Inputs). The employment field is
// identified by its label; options come from the field metadata when supplied,
// otherwise fall back to this list.
const EMPLOYMENT_FIELD_LABEL = 'Employment Type'
const EMPLOYMENT_OPTIONS = ['Intern', 'Full-time', 'Trainee']

function applyEmploymentFieldType(fields) {
    return fields.map(field => {
        if (typeof field.label === 'string' && field.label.trim() === EMPLOYMENT_FIELD_LABEL) {
            const options = field.options ?? EMPLOYMENT_OPTIONS
            // Default the employment type to the first option ("Intern") when unset.
            const value = field.value ? field.value : options[0]
            return { ...field, fieldType: 2, options, value }
        }
        return field
    })
}

export default function RecipientForm({ fieldsData, handleCancel, isIndex, doc, onUpdate }) {
    const [formData, setFormData] = useState([])
    const [notifData, setNotifData] = useState([])
    const [loading, setLoading] = useState(false)
    const holder_data=JSON.parse(localStorage.getItem("holder_data"))
    const verifier_request_id=holder_data?.verifier_request_id
    const user_data=useSelector(state=>state.User)
    const segregateNotifData = (data) => {
        let fieldsData = applyEmploymentFieldType(_.cloneDeep(data))
        setFormData(fieldsData.filter(field => !field.label.startsWith('Notification')))
        setNotifData(fieldsData.filter(field => field.label.startsWith('Notification')))
    }
    useEffect(() => {
        segregateNotifData(fieldsData)
    }, [fieldsData])

    function handleFormChange(value, index, item) {
        let temp = _.cloneDeep(formData)
        temp[index].value = value
        if (temp[index].type === 'number') {
            if (value.length > 0 && !isNumber(value))
                temp[index].error = 'Enter valid input'
            else {
                delete temp[index].error
                if (value.length > 0)
                    temp[index].value = parseInt(value)
            }
        }
        else {
            if (value.length > 0){
                if (item.field_name === "Document State") {
                    temp = temp.map(field =>
                        field.field_name === "Reason For Hold"
                            ? {
                                ...field,
                                isRequired: value === "DRAFT"
                            }
                            : field
                    );
                }
                delete temp[index].error
            }
        }
        if (value.length === 0 && !temp[index].isRequired) {
            delete temp[index].error
        }
        setFormData(temp)
    }

    function handleNotifChange(value, index) {
        let temp = _.cloneDeep(notifData)
        temp[index].value = value
        if (temp[index].type === 'number') {
            if (value.length > 0 && !isNumber(value))
                temp[index].error = 'Enter valid input'
            else {
                delete temp[index].error
                if (value.length > 0)
                    temp[index].value = parseInt(value)
            }
        }
        else {
            if (value.length > 0)
                delete temp[index].error
        }
        if (value.length === 0 && !temp[index].isRequired) {
            delete temp[index].error
        }
        setNotifData(temp)
    }
    function resetForm() {
        segregateNotifData(fieldsData)
        if (handleCancel) {
            handleCancel()
        }
    }
    function validateData() {
        let data = [...formData, ...notifData]
        let isValid = true
        let temp = []
        data.forEach(item => {
            if (item.error)
                isValid = false
            if (item.value != undefined || item.value != null || item.value == '') {
                if (item.isRequired && item.value.length === 0) {
                    isValid = false
                    item.error = "*Required!"
                }
            }
            if (
                item.field_name === "Reason For Hold" &&
                item.value?.length > 25
            ) {
                isValid = false;
                item.error = "Maximum 25 characters are allowed";
            }
            temp.push(item)
        })
        segregateNotifData(temp)
        if (!isValid) {
            cogoToast.error('Please Enter valid inputs!')
            return
        }
        else
            saveFormData(data)

    }
    async function saveFormData(data) {
        let params = {}
        let isNew = isIndex == 0 || isIndex ? false : true
        let URL = isNew ? INSERT_ISSUER_DOCUMENT : UPDATE_DOCUMENT_DATA
        params.doc_data = {}
        data.forEach(item => {
            params.doc_data[item.field_name] = item.value
            if (!isNew) {
                params.issued_uuid = item.issued_uuid
                params.notification_id = item.notification_id
            }
        })
        if (isNew) {
            params.issuer_id = doc.issuer_id
            params.document_id = doc.id
        }

        setLoading(true)
        await Delay()
        API.post(URL, { ...params })
            .then(res => {
                setLoading(false)
                cogoToast.success(res.data.message)
                onUpdate(fieldsData, true)

            })
            .catch(err => {
                setLoading(false)
                let error = err.response.data.detail?.[0]
                // console.log(error)
                try {
                    error = error.errors
                    // if (typeof error==='object')
                    //     cogoToast.error(<div>
                    //         {Object.keys(error).map(item => {
                    //             return <p>{_ToNormal(item.trim())}:{error[item].join(",")}</p>
                    //         })}
                    //     </div>, { hideAfter: 7 })

                    // data.map(item => {
                    //     if (item.field_name in error) {
                    //         item.error = error[item.field_name].join(',')
                    //     }
                    // })
                    const errorKeys = Object.keys(error)
                        .map(key => key.replace(/_/g, ' ')) // Replace underscores with spaces
                        .join(', ');
                    cogoToast.error(errorKeys + " are invalid")


                }
                catch (e) {
                    cogoToast.error(err.response.data.message)
                }

                segregateNotifData(data)
            })
    }
    return <section className="recipient-form">
        {/* <Loader isOpen={loading} /> */}
        <h3 className='p-1' style={{ margin: 0 }} >Document Fields<span className='info-icon'>
            <Icon icon={informationCircled} />
            <span className="tooltip-text">
                Document Fields .<br />
            </span>
        </span>
        </h3>
        <div className='row'>
            <Each of={formData} render={(item, index) => {
                return <div className='col-4 p-1 pt-1 pb-0' key={index}>
                    <WithInputType {...item} onChange={e => handleFormChange(e, index, item)} />
                </div>
            }} />

        </div>
        {/* <hr /> */}

        {notifData.length > 0 ? 
        <>
        <h3 className='p-1' style={{ margin: 0 }} >Notification Fields<span className='info-icon'>
            <Icon icon={informationCircled} />
            <span className="tooltip-text">
                Below fields will be used to notify the document holder.
            </span>
        </span>
        </h3>
        <div className='row'>
            <Each of={notifData} render={(item, index) => {
                return <div className='col-4 p-1 pt-1 pb-0' key={index}>
                    <WithInputType {...item} onChange={e => handleNotifChange(e, index)} />
                </div>
            }} />
        </div>
        </> : null}

        <div className='row'>
            <div className='col pl-1'>
                <button className='btn btn-secondary' onClick={e => resetForm()}>Cancel</button>
                <button className='btn btn-primary' disabled={loading} onClick={validateData} style={{ width: "fit-content" }}>
                    {loading ? <BtnLoader label={BUTTONS.SAVE} /> : BUTTONS.SAVE}
                </button>
            </div>
        </div>
    </section>
}
